export enum KeyOps {
  Sign = 1,
  Verify = 2,
  Encrypt = 3,
  Decrypt = 4,
  WrapKey = 5,
  UnwrapKey = 6,
  DeriveKey = 7,
  DeriveBits = 8,
  MACCreate = 9,
  MACVerify = 10,
}
